import { render, staticRenderFns } from "./Closeds.vue?vue&type=template&id=3f0f0576"
import script from "./Closeds.vue?vue&type=script&lang=js"
export * from "./Closeds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports